import React from 'react';
import { Wrapper } from '../../styled';
import { Separator } from 'Common/Components/CustomActionBar/styled';
import { ActionContainer } from './styled';
import AgentSelector from './components/AgentSelector';
import Delete from './components/Delete';
import Search from './components/Search';
import Paginator from './components/Paginator';

const RunStatusLog = () => {
  return (
    <Wrapper>
        <ActionContainer>
            <AgentSelector />
            <Separator />
            <Search />
            <Delete />
        </ActionContainer>
        <Paginator />
    </Wrapper>
  );
};
export default RunStatusLog;
